module.exports = __webpack_public_path__ + "img/voucher.1da0e905.png";